// document.addEventListener("DOMContentLoaded", () => {
//     gsap.registerPlugin(ScrollTrigger);
  
//     const homeMasthead = document.querySelector(".home-masthead");
//     if (!homeMasthead || homeMasthead.length === 0) return;

//     const mastheadHeading = homeMasthead.querySelector("h1");
//     const mastheadDescription = homeMasthead.querySelector("p");
//     const mastheadLink = homeMasthead.querySelector("a");

//     const tl = gsap.timeline();

//     if (mastheadHeading) {
//       tl.from(mastheadHeading, {
//         opacity: 0,
//         y: 30,
//         filter: "blur(8px)",
//         duration: 0.8,
//         ease: "power2.out"
//       });
//     }
  
//     if (mastheadDescription) {
//       tl.from(mastheadDescription, {
//         opacity: 0,
//         y: 20,
//         filter: "blur(8px)",
//         duration: 0.6,
//         ease: "power2.out"
//       }, "-=0.3");
//     }
  
//     if (mastheadLink) {
//       tl.from(mastheadLink, {
//         opacity: 0,
//         y: 0,
//         filter: "blur(8px)",
//         duration: 0.5,
//         ease: "power2.out"
//       }, "-=0.2");
//     }
// });

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  const homeMasthead = document.querySelector(".home-masthead");
  if (!homeMasthead || homeMasthead.length === 0) return;

  const mastheadHeading = homeMasthead.querySelector("h1");
  const mastheadDescription = homeMasthead.querySelector("p");
  const mastheadLink = homeMasthead.querySelector("a");

  const tl = gsap.timeline();

  if (mastheadHeading) {
    tl.from(mastheadHeading, {
      opacity: 0,
      y: 30,
      filter: "blur(8px)",
      duration: 0.8,
      ease: "power2.out"
    });
  }

  if (mastheadDescription) {
    tl.from(mastheadDescription, {
      opacity: 0,
      y: 20,
      filter: "blur(8px)",
      duration: 0.6,
      ease: "power2.out"
    }, "-=0.3");
  }

  if (mastheadLink) {
    tl.from(mastheadLink, {
      opacity: 0,
      y: 0,
      filter: "blur(8px)",
      duration: 0.5,
      ease: "power2.out"
    }, "-=0.2");
  }

  // ✅ Character split + hover animation
  document.querySelectorAll('.link-animate').forEach(link => {
  const originalLabel = link.querySelector('.link-label.original');
  const animatedLabel = link.querySelector('.link-label.animated');

  if (!originalLabel || !animatedLabel) return;

  const splitOriginal = new SplitText(originalLabel, { type: "chars" });
  const splitAnimated = new SplitText(animatedLabel, { type: "chars" });

  // Set initial positions:
  gsap.set(splitOriginal.chars, { yPercent: 0 });
  gsap.set(splitAnimated.chars, { yPercent: 100 }); // starts hidden below

  link.addEventListener('mouseenter', () => {
    gsap.to(splitOriginal.chars, {
      yPercent: -100,
      duration: 0.3,
      ease: "power2.out",
      stagger: 0.02
    });

    gsap.to(splitAnimated.chars, {
      yPercent: 0,
      duration: 0.3,
      ease: "power2.out",
      stagger: 0.02
    });
  });

  link.addEventListener('mouseleave', () => {
    gsap.to(splitOriginal.chars, {
      yPercent: 0,
      duration: 0.3,
      ease: "power2.in",
      stagger: 0.015
    });

    gsap.to(splitAnimated.chars, {
      yPercent: 100,
      duration: 0.3,
      ease: "power2.in",
      stagger: 0.015
    });
  });
});
});